

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getStar } from '@/api/user/user';

@Component({
  components: {},
})
export default class List extends Vue {
  @Prop() private data!: object[];
  @Prop() private total!: any;
  @Prop() private currentPage!: string;
  private myStar: object = {};
  // 获取登录信息
  get userInfo() {
    return this.$store.state.userInfo;
  }
  // 默认当前页面为普通任务页
  private statusMap: object = {
    '0': {
      class: 'status-no',
      text: {
        judge: '未领取',
        team: '未领取',
        crowd: '未考核',
      },
      detail: '从未考核或考核失败',
    },
    '1': {
      class: 'status-yes',
      text: {
        judge: '已领取',
        team: '已领取',
        crowd: '已通过',
      },
      detail: '',
    },
    '2': {
      class: 'status-no',
      text: {
        judge: '审核中',
        team: '审核中',
        crowd: '考核结果审核中',
      },
      detail: '等待管理员审核中',
    },
    '3': {
      class: 'statue-no',
      text: {
        judge: '已失败',
        team: '已失败',
        crowd: '考核失败，重新考核',
      },
      detail: '考核失败次数已达到最大次数',
    },
  };
  private statusKeyMap: object = {
    judge: {
      statusKey: 'status',
    },
    team: {
      statusKey: 'pull',
    },
    crowd: {
      // statusKey: 'status',
      statusKey: 'study_success',
    },
  };
  private created() {
    if (this.userInfo && this.userInfo.id) {
      this.getMyStar();
    }
  }
  // 获取我的星级 {type:level}
  private async getMyStar() {
    const res: any = await getStar();
    let obj = {};
    res.forEach((item, idx) => {
      obj[item.key] = item.level;
    });
    this.myStar = obj;
  }
  // 跳转详情页
  private goDetail(id) {
    this.$router.push({
      name: 'detail',
      params: { page: this.currentPage, id: id },
    });
  }
}
